export const ROLE_LABELS = {
  Admin: 'Administrator',
  TeamLead: 'Team Lead',
  User: 'Recruiter',
};

export const getDashboardPath = (userType) => {
  if (userType === 'Admin') return '/dashboard';
  if (userType === 'TeamLead') return '/dashboard';
  return '/dashboard';
};

const adminMenu = [
  {
    id: 'dashboard',
    label: 'Dashboard',
    icon: '📊',
    path: '/dashboard',
  },
  {
    id: 'requirements',
    label: 'Requirements',
    icon: '📋',
    path: '/requirements',
    children: [
      { label: 'Requirement Hub', path: '/requirements' },
      { label: 'My Requirements', path: '/Requirments/mine' },
      { label: 'Add Requirement', path: '/requirements', action: 'create-requirement' },
      { label: 'Requirement List', path: '/Requirments' },
    ],
  },
  {
    id: 'reports',
    label: 'Reports',
    icon: '📈',
    path: '/reports',
    children: [
      { label: 'Reports Hub', path: '/reports' },
      { label: 'Recruitment Analytics', path: '/reports/analytics' },
      { label: 'Employee Work Summary', path: '/admin/employee-work-summary' },
      { label: 'Recruiter / TL Requirement Details', path: '/admin/recruiter-tl-requirement-details' },
      { label: 'Status Tracking', path: '/reports/tracking' },
    ],
  },
  {
    id: 'clients',
    label: 'Clients',
    icon: '🏢',
    path: '/clients',
    children: [
      { label: 'Client Hub', path: '/clients' },
      { label: 'Add Client', path: '/clients', action: 'create-client' },
      { label: 'Client List', path: '/clients/list' },
    ],
  },
  {
    id: 'users',
    label: 'Users',
    icon: '👥',
    path: '/users',
    children: [
      { label: 'User Hub', path: '/users' },
      { label: 'Create User', path: '/users', action: 'create-user' },
      { label: 'User List', path: '/users/list' },
      { label: 'Team Leads', path: '/users/list?role=TeamLead' },
    ],
  },
  {
    id: 'candidates',
    label: 'Source Profiles',
    icon: '🧑‍💼',
    path: '/candidates',
    children: [
      { label: 'Source Profiles Hub', path: '/candidates' },
      { label: 'View Source Profiles', path: '/Requirments' },
    ],
  },
  {
    id: 'interviews',
    label: 'Interview Schedule',
    icon: '📅',
    path: '/work/interviews',
  },
  {
    id: 'settings',
    label: 'Settings',
    icon: '⚙️',
    path: '/settings',
    children: [
      { label: 'Settings Hub', path: '/settings' },
      { label: 'Profile', path: '/Profile' },
    ],
  },
];

const teamLeadMenu = [
  { id: 'dashboard', label: 'Dashboard', icon: '📊', path: '/dashboard' },
  {
    id: 'requirements',
    label: 'Requirements',
    icon: '📋',
    path: '/team/requirements',
    children: [
      { label: 'My Requirements', path: '/TLHome' },
      { label: 'Requirements', path: '/team/requirements' },
      { label: 'Assign Requirement', path: '/team/assign-requirements' },
    ],
  },
  {
    id: 'reports',
    label: 'Reports',
    icon: '📈',
    path: '/reports',
    children: [
      { label: 'Status Tracking', path: '/reports/tracking' },
      { label: 'My Sourced Profiles', path: '/work/my-sourced-profiles' },
    ],
  },
  {
    id: 'recruiters',
    label: 'Assigned Recruiters',
    icon: '👥',
    path: '/team/recruiters',
  },
  {
    id: 'clients',
    label: 'Assigned Clients',
    icon: '🏢',
    path: '/team/clients',
  },
  {
    id: 'work',
    label: 'Today Work',
    icon: '📅',
    path: '/work/today',
    children: [
      { label: 'Today Monitor', path: '/work/today' },
      { label: 'Interview Schedule', path: '/work/interviews' },
      { label: 'Profiles View', path: '/team/profiles-view' },
    ],
  },
  {
    id: 'settings',
    label: 'Settings',
    icon: '⚙️',
    path: '/settings',
    children: [{ label: 'Profile', path: '/Profile' }],
  },
];

const recruiterMenu = [
  { id: 'dashboard', label: 'Dashboard', icon: '📊', path: '/dashboard' },
  { id: 'workbench', label: 'My Workbench', icon: '📋', path: '/home?tab=claimed' },
  { id: 'my-sourced-profiles', label: 'My Sourced Profiles', icon: '🧑‍💼', path: '/work/my-sourced-profiles' },
  { id: 'interviews', label: 'Interview Schedule', icon: '📅', path: '/work/interviews' },
  { id: 'profile', label: 'Profile', icon: '👤', path: '/Profile' },
];

export const getNavigationMenu = (userType) => {
  if (userType === 'Admin') return adminMenu;
  if (userType === 'TeamLead') return teamLeadMenu;
  return recruiterMenu;
};

export const getPageTitle = (pathname) => {
  const map = {
    '/dashboard': 'Dashboard',
    '/requirements': 'Requirements',
    '/clients': 'Clients',
    '/clients/list': 'Client List',
    '/users': 'Users',
    '/users/list': 'User List',
    '/candidates': 'Source Profiles',
    '/reports': 'Reports',
    '/reports/analytics': 'Recruitment Analytics',
    '/admin/employee-work-summary': 'Employee Work Summary',
    '/admin/recruiter-tl-requirement-details': 'Recruiter / TL Requirement Details',
    '/reports/tracking': 'Status Tracking',
    '/work/today': 'Today Work Monitor',
    '/work/my-today': "Today's Work",
    '/work/my-sourced-profiles': 'My Sourced Profiles',
    '/work/interviews': 'Interview Schedule',
    '/settings': 'Settings',
    '/Requirments': 'Requirement List',
    '/Requirments/mine': 'My Requirements',
    '/Adminaddnewrequirements': 'Add Requirement',
    '/AdminCreateUser': 'Create User',
    '/CreateClient': 'Create Client',
    '/Clients': 'Client List',
    '/Users': 'User List',
    '/Profile': 'Profile',
    '/home': 'My Workbench',
    '/admin/profiles-view': 'Profiles View',
    '/team/profiles-view': 'Profiles View',
    '/TLHome': 'My Requirements',
    '/team/requirements': 'Requirements',
    '/team/assign-requirements': 'Assign Requirement',
    '/team/recruiters': 'Assigned Recruiters',
    '/team/clients': 'Assigned Clients',
    '/TeamClient': 'Assigned Clients',
    '/TLNewReq': 'Add Requirement',
    '/UpdateUser': 'Update User',
    '/UptadeClient': 'Update Client',
  };
  if (map[pathname]) return map[pathname];
  if (pathname.startsWith('/UpdateUser')) return 'Update User';
  if (pathname.startsWith('/UptadeClient')) return 'Update Client';
  if (pathname.startsWith('/UserAction')) return 'Source Profile Actions';
  if (pathname.startsWith('/ClientProfile')) return 'Client Profile';
  return 'HR Management';
};
